export default __webpack_public_path__ + "static/media/denied.6d1bce15.svg";